export default __webpack_public_path__ + "static/media/blast_logo.dcb7f957.svg";